export default "__VITE_ASSET__c158a343__"